{ logoDomain } = require '@trello/config'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('board_menu_invite_team')


module.exports = class BoardMenuInviteTeamComponent extends React.Component
  render: t.renderable ->
    { onClick, availableToInvite } = @props

    t.div '.invite-team', { onMouseDown: onClick }, ->
      t.span '.icon-lg.icon-organization'
      t.div '.invite-team-text', ->
        t.format 'add-all-x-team-members', { memberCount: availableToInvite.length }
